export default __webpack_public_path__ + "static/poster-26eb06bdcd11ce2b66680296f392822a.png";